export const linkWrapperStyle = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: 2,
  gridTemplateColumns: {
    xs: "repeat(auto-fit, minmax(150px, 1fr))",
    sm: "repeat(auto-fit, minmax(250px, 1fr))",
  },
  justifyContent: "space-between",
  alignItems: "center",
}

export const linkStyle = {
  textDecoration: "none",
  color: "darkSecondary",
  fontSize: 14,
}

export const logoWrapperStyle = {
  flexBasis: { md: "50%" },
}

export const copyrightStyle = {
  flexBasis: { md: "50%" },
  textDecoration: "none",
  color: "darkSecondary",
  fontSize: 14,
  gridColumn: "span 2",
  textAlign: { xs: "center", md: "end" },
}

export const textLogoStyle = {
  display: "flex",
  gap: 1,
  alignItems: "start",
  fontSize: 24,
  fontWeight: 700,
}

export const iconWrapperStyle = {
  display: "flex",
  alignItems: "center",
}

export const normalTextStyle = {
  fontSize: 16,
  fontWeight: 400,
}
